export default __webpack_public_path__ + "static/media/direpay.51e507d7.svg";